export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LogosList.vue?vue&type=template&id=2c5d8f9d&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/LogosList.vue?vue&type=template&id=2c5d8f9d&scoped=true&
// module id = 215
// module chunks = 0